import { storage } from '@/utils/storage'

export default defineNuxtPlugin(() => {
  const route = useRoute()
  const { setToken } = useAuthToken()

  // 定義需要處理的參數
  const paramsConfig = [
    { key: 'channel', name: 'channel' },
    { key: 'subchannel', name: 'subchannel' },
    { key: 'ac', name: 'affiliate code' },
    { key: 'fc', name: 'friend code' },
    { key: 'pix', name: 'Pixel' },
    { key: 'kpix', name: '快手' },
  ]

  // 有效期：7 天（秒為單位）
  const maxAge = 60 * 60 * 24 * 7

  paramsConfig.forEach(({ key, name }) => {
    const value = route.query[key]

    // 防呆：只有在值存在且不為空時才儲存
    if (typeof value === 'string' && value.trim() !== '') {
      storage.set(key, value, {
        path: '/',
        maxAge,
      })
      console.info(`[urlParams] ${name} (${key}) saved to localStorage: ${value}`)
    }
  })

  const token = route.query.x
  if (token) {
    setToken(token)
  }
})
